import get from 'lodash/get';
import values from 'lodash/values';
import flatten from 'lodash/flatten';
import find from 'lodash/find';
// import has from 'lodash/has';

import { alphabeticallySort, firstNonZeroOrOne }  from '../utils';

export function getActiveUser(state){
  const userId = get(state,['entities','activeUserId']);
  return get(state,['entities','users',userId],{});
}

export function getIsImpersonating(state){
  return get(state,['session','getIsImpersonating'],false);
}

export function getActiveAgencyUser(state){
  const userId = get(state,['entities','activeUserId']),
    impersonatedUserId = get(state,['entities','impersonatedUserId']);

  if(impersonatedUserId){
    return get(state,['entities','users',impersonatedUserId],{});
  } else if(userId) {
    let user = get(state,['entities','users',userId],{});
    if(user.agencyId === 'mynfo'){
      return {}
    } else {
      return user;
    }
  } else {
    return {};
  }
}

export function getAgencyUsers(state,agencyId){
  if(agencyId){
    return values(state.entities.users)
      .filter((u) => !u.isProvider)
      .filter((u) => u.agencyId === agencyId)
  } else {
    return [];
  }
}

export function getActiveProviderUser(state){
  const userId = get(state,['entities','activeUserId']);

  if(get(state,['entities','users',userId,'isProvider'])){
    return get(state,['entities','users',userId],{})
  } else {
    return null;
  }
}

export function getCampaignsWithKPIs(state){
  return values(state.entities.campaigns)
    .sort((a,b) => firstNonZeroOrOne([
      alphabeticallySort(a.status,b.status),
      alphabeticallySort(a.name,b.name)
    ]))
    .map((c) => {
      c.name = c.name || 'Untitled campaign';
      c.budgetSpent = get(state,['kpis','campaigns',c.id,'budgetSpent'],0) || 0;
      c.numCompletions = get(state,['kpis','campaigns',c.id,'numCompletions'],0) || 0;
      c.averageRating = get(state,['kpis','campaigns',c.id,'averageRating'],0) || 0;
      c.brandName = get(state,['entities','companies',c.companyId,'name'],'Unknown Brand') || 'Unknown Brand';
      c.isOrHasBeenLive = ['active','complete','suspended','outOfFunds'].indexOf(c.status) >= 0;
      c.demoIsOrHasBeenLive = ['active','complete','suspended','outOfFunds'].indexOf(c.demoStatus) >= 0; 

      return c;
    });    
}

export function getBrandsWithKPIs(state){
  return values(state.entities.companies)
      .filter((b) => b.name && b.name.length > 0 && b.isBrand)
      .sort((a,b) => alphabeticallySort(a.name,b.name))
      .map((b) => {
        b.totalCampaigns = get(state,['kpis','brands',b.id,'totalCampaigns'],0) || 0;
        b.agencyName = get(state,['entities','agencies',b.agencyId,'name']);
        return b;
      });
}

export function getAgencyPrograms(state, agencyId){
  if(agencyId){
    return values(state.entities.programs)
        .filter((u) => u.agencyId === agencyId)
  } else {
    return [];
  }
}

export function getBrandReceiptLineups(state, brandId){
  if(brandId){
    return values(state.entities.receiptLineups)
        .filter((u) => u.brandId === brandId)
  } else {
    return [];
  }
}

export function getEngagementsWithKPIs(state){
  return flatten(values(state.kpis.engagements)
    .map((c) => c.engagementKPIs
      .map((k) => {
        const e = get(state,['entities','engagements',k.engagementId],{}) || {};

        k.answerKPIs = k.answerKPIs.map((a) => {
          if(a.answer !== '0' && a.answer !== '1' && e.options){
            const o = find(e.options,(o) => o.answerId === a.answer);
            return Object.assign({},o,a);
          } else {
            return a;
          }
        });

        return Object.assign({},e,k);
      })
      .sort((a,b) => b.ordinal - a.ordinal)))
}

export function getPaymentMethodsForAgency(state,agencyId){
  if(agencyId){
    return values(state.entities.paymentMethods)
      .filter((p) => p.agencyId === agencyId)
      .filter((p) => p.kind === 'card')
      .filter((p) => p.active);
      
  } else {
    return [];
  }
}

export function getAllPaymentMethodsForAgency(state,agencyId){
  if(agencyId){
    return values(state.entities.paymentMethods)
      .filter((p) => p.agencyId === agencyId)
      
  } else {
    return [];
  }  
}


// WEBPACK FOOTER //
// ./src/shared/redux/selectors.js